// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --prod` then `environment.cb-production.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import {NgxLoggerLevel} from 'ngx-logger';

export const environment = {
  production: true,
  orderPrefix: "ST",
  tenant: "cb",
  logos: {
    small: "assets/images/cb/logo-symbol.png",
    large: "assets/images/cb/logo.svg",
  },

  apiHost: "https://api.sandbox.companybox.com",
  designerHost: "https://app.sandbox.companybox.com/",

  logger: {
    logLevel: NgxLoggerLevel.INFO,
    serverLogLevel: NgxLoggerLevel.OFF,
    serverLoggingUrl: undefined,
  },
};
